import 'bootstrap-daterangepicker';
import 'angular-daterangepicker';

import { NgModule } from 'ng-metadata/core';
import { SearchVisasComponent } from './visas/search-visas.component';
// import { SearchPassportsComponent } from './passports/search-passports.component';
import { SlugifyPipe } from '../../pipes/slug.pipe';
import './search.scss';

@NgModule({
  imports: [
    // https://github.com/fragaria/angular-daterangepicker
    'daterangepicker',
  ],
  declarations: [
    SlugifyPipe,
    SearchVisasComponent,
  ],
})
export class SearchModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/search/search.module.ts